import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';
import {GruposPaginas} from '../../configs/iluminação'

const ApoioPagina = () => {
  return (
    <div className="apoio-container">
      <GroupLightComponent
        groupIds={GruposPaginas[2]}
        pageTitle="Luzes do apoio" 
      />
    </div>
  );
};

export default ApoioPagina;